import { useState } from 'react';
import { Modal, ModalContent, ModalBody, ModalFooter, Button } from '@heroui/react';
import { PlusIcon } from '@heroicons/react/24/solid';

interface ComposeImgProps {
  thumb: string;
  full: string;
  alt?: string;
  className?: string;
}

const ComposeImg = ({ thumb, full, alt = 'Image', className }: ComposeImgProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div
        className={`relative group overflow-hidden rounded-lg cursor-pointer ${className}`}
        onClick={handleOpenModal}
      >
        <img
          src={thumb}
          alt={alt}
          className="w-full h-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-transparent bg-opacity-0 group-hover:bg-opacity-50 transition-all duration-300 ease-in-out flex items-center justify-center">
          <div className="w-12 h-12 bg-black bg-opacity-20 rounded-full flex items-center justify-center">
            <PlusIcon className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </div>
        </div>
      </div>

      <Modal isOpen={isModalOpen} onOpenChange={setIsModalOpen} size="3xl" placement="center" shadow='lg'>
        <ModalContent>
          {() => (
            <>
              <ModalBody className="flex items-center justify-center">
                <img src={full} alt={alt} style={{ maxWidth: '90vw', maxHeight: '80vh', objectFit: 'contain' }} />
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="flat" onClick={handleCloseModal}>
                  Close
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

export default ComposeImg;
